import { freePreviewState } from './freePreview.js';

export const FREE_ONBOARDING_PATH = '/onboarding?source=free-preview';

export function isFirstPostOnboarding(entitlements) {
  return (entitlements?.data ?? entitlements)?.freePreview?.experiment === 'free_onboarding_v1';
}

// This is an entry hint, never permission to run AI or ordinary generation.
export function freeOnboardingAvailable(entitlements) {
  const data = entitlements?.data ?? entitlements;
  const entry = data?.freeOnboarding;
  return entry?.available === true && typeof entry.requiresVerification === 'boolean' && [1, 3].includes(entry.draftsLimit);
}

export function freeOnboardingDestination(entitlements) {
  const preview = freePreviewState(entitlements);
  if (preview?.mode === 'verify') return '/app?preview=1';
  return preview?.mode === 'active' ? FREE_ONBOARDING_PATH : null;
}
